import request from '../../utils/request';
import {baseDomain} from '../baseDomain'

// 查询(组织架构，公司荣誉)图片
export const selectcatfile = query => {
    return request({
        url: `${baseDomain}/uccn/article/selectcatfile`,
        method: 'post',
        data: query
    });
};
